// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3njbR","footer":"styles_footer__2NF0B","passCodeTooltip":"styles_passCodeTooltip__1bbXk"};